import { configureStore, combineReducers } from '@reduxjs/toolkit';
import widgetReducer from './slices/widget-slice';

const widgetRootReducer = combineReducers({
  widget: widgetReducer,
});

export const createWidgetStore = () => {
  return configureStore({
    reducer: widgetRootReducer,
  });
};

export type WidgetStore = ReturnType<typeof createWidgetStore>;
export type RootState = ReturnType<typeof widgetRootReducer>;
export type AppDispatch = ReturnType<typeof createWidgetStore>['dispatch'];
